import config from 'lib/config';
import { createInstance } from '@optimizely/react-sdk';

const optimizelyClient = createInstance({ sdkKey: config.optimizelySdkKey, logLevel: 4 });

export default optimizelyClient;
